import type { DeprecatedNumericSpaces } from '../../types';
import { space } from './base';

export const deprecatedSpace: DeprecatedNumericSpaces = [
  0,
  space['2x_small'],
  space['1x_small'],
  space['small'],
  space['base'],
  space['big'],
  space['1x_big'],
  space['2x_big'],
  space['3x_big'],
  56,
];
